var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndusFooterFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-label": "Facebook",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 21v-8h3l.5-3h-3.5V8.2c0-.9.3-1.7 1.8-1.7H18V3.8c-.5-.1-1.4-.2-2.5-.2-2.6 0-4.3 1.6-4.3 4.4v2H8v3h3.2v8Z",
    fill: "#C8D2E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndusFooterFacebook);
export default __webpack_public_path__ + "static/media/andus-footer-facebook.602776a2c8feb4d33c46158a9285ec27.svg";
export { ForwardRef as ReactComponent };